import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { Store, select } from '@ngrx/store';
import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

import { ResponseOrganization } from '../interfaces/organizations.interface';

import { environment } from '@unico-people/shared/utils/environments';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class DataAccessOrganizationsService {
  private url: string = environment.url_admission_api;
  private subject = new Subject<any>();

  constructor(private http: HttpClient, private store: Store<fromStore.DashboardState>) {}

    /**
   * Get organization and account infos
   * @param access_token token
   */
     getOrganization(access_token): Observable<ResponseOrganization> {
      const httpOptions = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${access_token}`
        }),
        withCredentials: true
      };
      return this.http.get<ResponseOrganization>(`${this.url}/organization`, httpOptions);
    }

    setOrganization(account) {
      const acc = account;
      let list = [];
      this.store.pipe(select(fromStore.getOrganizationState)).subscribe(res => {
        list = res?.groups;
      });

      if (list?.length > 0) {
        const companies = list.reduce((all, item) => {
          item?.accounts?.map(res => {
            all?.push(res);
          });
          return all;
        }, []);
        const account = companies.filter(x => x?.uid === acc)[0];
        this.store.dispatch(fromStore.changeAccount({ payload: account }));
        if (account?.name) {
          SessionStorage.setItem('currentAccountName', account?.name);
        }
        SessionStorage.setItem('currentAccount', acc);
        return account;
      }
    }

    sendAccount(account: any) {
      this.subject.next({ account });
    }

    clearAccount() {
      this.subject.next();
    }

    onAccount(): Observable<any> {
      return this.subject.asObservable();
    }
}
